import {
  FilterInternalArgumentsBase,
  FilterHookArgumentsBase,
} from '@core/providers/filters'
import { localizedStrings } from '@core/strings'

export type TextInputFilterHookArguments = FilterHookArgumentsBase<string> & {
  placeholder?: string
}

export type TextInputFilterInternalArguments = TextInputFilterHookArguments &
  FilterInternalArgumentsBase<string, 'TEXT_INPUT'>

export const useTextInputFilter: (
  filter: TextInputFilterHookArguments,
) => TextInputFilterInternalArguments = (filter) => {
  const nothingSelectedText =
    filter.nothingSelectedText || localizedStrings.search

  const unfocusedText = (value: any) => {
    if (typeof value === 'object') {
      return `${filter.label}: ${
        value?.value ? value.value : nothingSelectedText
      }`
    }

    return `${filter.label}: ${value ? value : nothingSelectedText}`
  }
  return {
    type: 'TEXT_INPUT',
    unfocusedText,
    nothingSelectedText,
    serialization: 'string',
    ...filter,
  }
}
